import React from "react"
import PropTypes from 'prop-types'

import PopupMenuButton from "../../../../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import DocPageMoreMenu from "./more-menu"

interface DocPageMorePropTypes {
    className?  : string,
    onDelete    : any,
}

export default class DocPageMoreButton  extends React.Component<DocPageMorePropTypes, any> {

    static propTypes = {
        onDelete: PropTypes.func
    }

    render() {
        const classes = Classes("more ui5-ico-more s20", this.props.className)
        // const classes = Classes("more ui5-control-button s-24 fs-20 ui5-ico-more", this.props.className)

        return <PopupMenuButton className={classes}
                                attachment="top center"
                                targetAttachment="bottom center"
                                offset="0 0"
                                menuComponent={DocPageMoreMenu}
                                menuParams={{
                                    onDelete: this.props.onDelete
                                }}/>
    }
}
